import { CountriesAllowedProfSellersApi } from '@/types/other';

export default async function getProfessionalSellersCountriesAllowed(): Promise<CountriesAllowedProfSellersApi> {
  try {
    // this api gets all the countries allowed by spiritory
    const response = await fetch('/api/get-professional-sellers-countries');

    if (!response.ok) {
      throw new Error('Error fetching countries');
    }

    const countries = await response.json();

    if (!countries) {
      throw new Error('Error fetching countries');
    }

    return countries;
  } catch (e) {
    throw new Error("Countries couldn't be fetched.");
  }
}
